export enum RequestActionLogDepartment {
	FollowUp = "FOLLOW_UP",
	Investigation = "INVESTIGATION",
	Prosecution = "PROSECUTION",
	Discipline = "DISCIPLINE",
}
